// Sharing endpoints. getBugReportUrl resolves a shared bug-report id to the
// destination URL the browser should be handed to (`{ url }` — a link, never
// the content). loginToken-authorized: shared links are opened from the
// pre-company session, outside the app shell. keepUnusedDataFor: 0 so a
// revisit re-resolves instead of replaying a possibly-expired link from cache.

import { baseApi } from '../baseApi';
import { ROUTES } from '../routes';

interface ApiBugReportUrl {
  url: string;
}

export const sharingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBugReportUrl: build.query<string, string>({
      query: (id) => ({ ...ROUTES.sharing.bugReport(id) }),
      transformResponse: (res: ApiBugReportUrl) => res.url,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetBugReportUrlQuery } = sharingApi;
